import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param orgId
 */
class UomService {
  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
   createUom = async (payload) => {
     const createdUom = await Helpers.post({
       url: Constants.UOMS,
       data: payload,
     });
     return createdUom;
   };

  /**
   * @param orgId
   * @param page
   * @param limit
   * @param isActive
   * @param uomName
   * @return {Promise<*>}
   */
  getUoms = async (orgId, page, limit, isActive, uomName) => {
    let url = `${Constants.UOMS}?`;
    if (isActive) url += `is_active=${isActive}&`;
    if (orgId) url += `org_id=${orgId}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (uomName) url += `uom_name=${uomName}&`;

    const uoms = Helpers.get({ url });
    return uoms;
  };

  /**
   * @param payload
   * @return {Promise<*>}
   */
  updateUom = async (payload) => {
    const updateUom = await Helpers.put({
      url: Constants.UOMS,
      data: payload,
    });
    return updateUom;
  };
}
export default new UomService();
